export const mfManifestsPath = '/assets/module-federation.manifest.dev6.json'
